(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LP-pair-section"] && !Shopify.designMode) return;
  try {
    
    const track = document.querySelector('.LP-rank-carousel-track');
    const items = document.querySelectorAll('.LP-rank-carousel-item');
    const prevButton = document.querySelector('.LP-rank-carousel-control.prev');
    const nextButton = document.querySelector('.LP-rank-carousel-control.next');

    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID;

    const updateCarousel = () => {
        const itemWidth = items[0].getBoundingClientRect().width + 18;
        const maxIndex = items.length - Math.ceil(track.offsetWidth / itemWidth);
        currentIndex = Math.min(Math.max(currentIndex, 0), maxIndex);
        track.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
    };

    const setPositionByIndex = () => {
        const itemWidth = items[0].getBoundingClientRect().width + 18;
        currentTranslate = -currentIndex * itemWidth;
        prevTranslate = currentTranslate;
        track.style.transform = `translateX(${currentTranslate}px)`;
    };

    const animation = () => {
        track.style.transform = `translateX(${currentTranslate}px)`;
        if (isDragging) requestAnimationFrame(animation);
    };

    const touchStart = (index) => (event) => {
        isDragging = true;
        startX = getPositionX(event);
        animationID = requestAnimationFrame(animation);
        track.classList.add('grabbing');
    };

    const touchMove = (event) => {
        if (!isDragging) return;
        const currentPosition = getPositionX(event);
        currentTranslate = prevTranslate + currentPosition - startX;
    };

    const touchEnd = () => {
        isDragging = false;
        cancelAnimationFrame(animationID);
        const movedBy = currentTranslate - prevTranslate;
        const itemWidth = items[0].getBoundingClientRect().width + 18;
        if (movedBy < -100 && currentIndex < items.length - 1) currentIndex += 1;
        if (movedBy > 100 && currentIndex > 0) currentIndex -= 1;
        setPositionByIndex();
        track.classList.remove('grabbing');
    };

    const getPositionX = (event) => {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    };

    items.forEach((item, index) => {
        item.addEventListener('dragstart', (e) => e.preventDefault());
        item.addEventListener('touchstart', touchStart(index));
        item.addEventListener('touchmove', touchMove);
        item.addEventListener('touchend', touchEnd);
        item.addEventListener('mousedown', touchStart(index));
        item.addEventListener('mousemove', touchMove);
        item.addEventListener('mouseup', touchEnd);
        item.addEventListener('mouseleave', touchEnd);
    });

    prevButton.addEventListener('click', () => {
        currentIndex -= 1;
        updateCarousel();
    });

    nextButton.addEventListener('click', () => {
        currentIndex += 1;
        updateCarousel();
    });

    window.addEventListener('resize', updateCarousel);

    updateCarousel();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
